import React from 'react';
import FrontPage from "./FrontPage/FrontPage";

import './App.css';

function App() {
  return (
    <div className="App">
      <FrontPage />
    </div>
  );
}

export default App;
